import React from "react";
import "../../style/portfolio.css";
import caseStudy from "../../images/caseStudy.png";

const CaseStudy = () => {
  return (
    <div className="portfolio-element">
      <div className="portfolio-left">
        <div className="image-container">
          <div className="image-wrapper">
            <img className="image" src={caseStudy} alt="case study" />
          </div>
        </div>
      </div>
      <div className="portfolio-right">
        <h1 className="headings-portfolio">Case Study</h1>
        <p>
          El objetivo era crear un sitio web REACT.JS y móvil para la Federación
          De Lucha Canaria de Gran Canaria. El sitio web es responsive y ha sido
          optimizado. Utiliza animaciones basadas en desplazamiento interactivo
          en las páginas.
        </p>
      </div>
    </div>
  );
};

export default CaseStudy;
